export const DownloadIcon = ({ width, height, viewBox, fill, styles }) => (
  <svg
    width={width || '16'}
    height={height || '17'}
    viewBox={viewBox || '0 0 16 17'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles}
  >
    <path
      d="M2 11.5V13C2 13.8284 2.67157 14.5 3.5 14.5H12.5C13.3284 14.5 14 13.8284 14 13V11.5M11 8.5L8 11.5M8 11.5L5 8.5M8 11.5V2.5"
      stroke="#0F172A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
